module.exports = __webpack_public_path__ + "img/55.36d3c900.jpg";